import { questionKeyLabels, questionTypes, randomValues } from "../../config";
import { Question } from "../../type";
import { removeSpace } from "../questions/utils";
import { get } from "lodash";

export function logicalCheck(questions: any[]) {
  let checkResults = [];
  const checkResults3 = checkFormatWhole(questions);
  checkResults = checkResults.concat(checkResults3);

  console.log(checkResults3);

  let checkResults4 = [];
  questions.forEach((question) => {
    const checkResults4Tmp = checkFormatByQuestion(question["questionId"], question);
    checkResults4 = checkResults4.concat(checkResults4Tmp);
  });
  console.log(checkResults4);
  checkResults = checkResults.concat(checkResults4);

  return checkResults;
}

function checkFormatWhole(questions: any[]) {
  const results = [];

  // ["questionTitle", "questionText"].forEach((key) => {
  //   questions.forEach((question) => {
  //     if (!question[key]) {
  //       results.push({
  //         message: `${key}が空白です`,
  //         detail: `設問ID: ${question["questionId"]}`,
  //         target: key,
  //         checkType: "blank",
  //       });
  //     }
  //   });
  // });

  // # question_titleの重複
  // 重複した questionTitle を取得
  const titleCountMap = questions.reduce((acc, question) => {
    const title = question["questionTitle"];
    acc[title] = (acc[title] || 0) + 1;
    return acc;
  }, {});

  const duplicatedTitles = Object.keys(titleCountMap).filter((title) => titleCountMap[title] > 1);

  duplicatedTitles.forEach((title) => {
    if (results.filter((r) => r.note === title).length == 0) {
      const targetQuestions = questions
        .filter((q) => q["questionTitle"] === title)
        .map((q) => q["questionId"]);
      results.push({
        reviewPoint: "invalid",
        target: get(questionKeyLabels, "questionTitle", ""),
        problem: `設問タイトルの重複（${title}）`,
        proposedRevision: `設問タイトルの重複を解消してください（${targetQuestions.join(",")}）`,
        must: false,
        note: title,
        questionId: targetQuestions[0],
      });
    }
  });

  // const uniqQuestionTitle = questions.reduce((acc, question) => {
  //   if (!acc.includes(question["questionTitle"])) {
  //     acc.push(question["questionTitle"]);
  //   }
  //   return acc;
  // }, []);

  // if (questions.length != uniqQuestionTitle.length) {
  //   results.push({
  //     reviewPoint: "invalid",
  //     target: get(questionKeyLabels, "questionTitle", ""),
  //     problem: "設問タイトルが重複しています",
  //     proposedRevision: "設問タイトルの重複を解消してください",
  //     must: false,
  //   });
  // }

  // // # question_textの重複
  // const uniqQuestionText = questions.reduce((acc, question) => {
  //   if (!acc.includes(question["questionText"])) {
  //     acc.push(question["questionText"]);
  //   }
  //   return acc;
  // }, []);
  // if (questions.length != uniqQuestionText.length) {
  //   results.push({
  //     reviewPoint: "invalid",
  //     target: get(questionKeyLabels, "questionText", ""),
  //     problem: "設問文が重複しています",
  //     proposedRevision: "設問文の重複を解消してください",
  //     must: false,
  //   });
  // }

  const textCountMap = questions.reduce((acc, question) => {
    const title = question["questionText"];
    acc[title] = (acc[title] || 0) + 1;
    return acc;
  }, {});

  const duplicatedTexts = Object.keys(textCountMap).filter((text) => textCountMap[text] > 1);
  duplicatedTexts.forEach((text) => {
    if (results.filter((r) => r.note === text).length == 0) {
      const targetQuestions = questions
        .filter((q) => q["questionText"] === text)
        .map((q) => q["questionId"]);
      results.push({
        reviewPoint: "invalid",
        target: get(questionKeyLabels, "questionText", ""),
        problem: `設問文の重複（${text}）`,
        proposedRevision: `設問文の重複を解消してください（${targetQuestions.join(",")}）`,
        must: false,
        note: text,
        questionId: targetQuestions[0],
      });
    }
  });

  return results;
}

function checkFormatByQuestion(questionId: string, question: Question) {
  let results = [];

  // -------------------------
  // ブランク
  // -------------------------

  ["questionId", "questionText", "questionType", "questionTitle"].forEach((key) => {
    if (!question[key]) {
      results.push({
        reviewPoint: "blank",
        target: `${questionId} - ${get(questionKeyLabels, key, "")}`,
        problem: `${questionId}の、${key}が記載されていません`,
        proposedRevision: `設問ID: ${questionId}の${key}を設定してください`,
        must: true,
        questionId: questionId,
      });
    }
  });

  if (!question.options.length) {
    results.push({
      reviewPoint: "blank",
      target: `${questionId} - 選択肢`,
      problem: `${questionId}の、選択肢が記載されていません`,
      proposedRevision: `設問ID: ${questionId}の選択肢を設定してください`,
      must: true,
      questionId: questionId,
    });
  }

  question.options.forEach((item) => {
    if (!question["questionType"].includes("TX")) {
      // # todo: 程度を問う質問の場合、空白を許可する
      if (
        !item["text"] &&
        results.filter((r) => r.reviewPoint === "blank" && r.questionId == questionId).length == 0
      ) {
        results.push({
          reviewPoint: "blank",
          target: `${questionId} - 選択肢`,
          problem: "選択肢が空白です",
          proposedRevision: `設問ID: ${questionId}の選択肢を設定してください`,
          questionId: questionId,
        });
      }
    }
  });

  question.optionHeaders.forEach((header) => {
    // ブランク
    if (!header.from || !header.to) {
      results.push({
        reviewPoint: "blank",
        target: `${questionId} - 選択肢グループ（見出し）`,
        problem: "選択肢がない選択肢グループが存在しています",
        proposedRevision: `設問ID: ${questionId}の選択肢グループを設定してください`,
        must: true,
        questionId: questionId,
      });
    }
  });

  // # 見出しのblankチェック
  const optionHeaders = question["optionHeaders"];
  if (optionHeaders.length != optionHeaders.filter((h) => h.label).length) {
    // if (optionHeaders.length == 1) {
    // if (!optionHeaders[0]) {
    results.push({
      reviewPoint: "blank",
      target: `${questionId} - 選択肢グループ（見出し）`,
      problem: "見出しが空白です",
      proposedRevision: `設問ID: ${questionId}の選択肢グループを設定してください`,
      must: false,
      questionId: questionId,
    });
    //   }
    // } else {
    //   const blankHeaders = optionHeaders.filter((h) => !h);
    //   if (blankHeaders.length >= 2) {
    //     results.push({
    //       reviewPoint: "blank",
    //       target: `${questionId} - 選択肢グループ（見出し）`,
    //       problem: "見出しが空白です",
    //       proposedRevision: `設問ID: ${questionId}の選択肢グループを設定してください`,
    //       must: false,
    //     });
    //   }
    // }
  }

  // -------------------------
  // 不正な値
  // -------------------------
  // # question_id
  if (!question["questionId"].match(/^(Q|QS|SQ|F)\d+$/)) {
    results.push({
      reviewPoint: "invalid",
      target: `${questionId} - 設問ID`,
      problem: "設問IDが不正です",
      proposedRevision: `設問ID: ${questionId}の設問IDを修正してください`,
      must: true,
      questionId: questionId,
    });
  }

  // # question_type
  if (!questionTypes.includes(question["questionType"])) {
    results.push({
      reviewPoint: "invalid",
      target: `${questionId} - 設問形式`,
      problem: "設問形式が不正です",
      proposedRevision: `設問ID: ${questionId}の設問形式を修正してください`,
      must: true,
      questionId: questionId,
    });
  }
  // # random
  if (
    removeSpace(question["random"]) &&
    randomValues.filter((rv) => question["random"].includes(rv)).length == 0
  ) {
    results.push({
      reviewPoint: "invalid",
      target: `${questionId} - ランダム設定`,
      problem: "ランダム設定の入力値が不正です",
      proposedRevision: `設問ID: ${questionId}のランダム設定を修正してください`,
      must: false,
      questionId: questionId,
    });
  }

  // # item_headers
  if (question["optionHeaders"].length) {
    // # item_headersの中で、同じ値がある場合、invalid
    const uniqueHeaders = question["optionHeaders"].reduce((acc, h) => {
      if (!acc.includes(h.label)) {
        return [...acc, h.label];
      }
      return acc;
    }, []);
    if (question["optionHeaders"].length != uniqueHeaders.length) {
      results.push({
        reviewPoint: "invalid",
        target: `${questionId} - 選択肢グループ（見出し）`,
        problem: "見出しが重複しています",
        proposedRevision: `設問ID: ${questionId}の選択肢グループを修正してください`,
        must: false,
        questionId: questionId,
      });
    }

    // # item_headers_random
    // if (question["itemHeadersRandom"].length) {
    question["optionHeaders"].forEach((header) => {
      // # item_headers_randomの中で、同じ値がある場合、invalid
      if (
        removeSpace(header.random) &&
        randomValues.filter((rv) => removeSpace(header.random).includes(rv)).length == 0
      ) {
        results.push({
          reviewPoint: "invalid",
          target: `${questionId} - ランダム設定`,
          problem: "見出しのランダム設定の入力値が不正です",
          proposedRevision: `設問ID: ${questionId}のランダム設定を修正してください`,
          must: false,
          questionId: questionId,
        });
      }
    });
    // }
  }

  question.options.forEach((item) => {
    // # exclusive
    if (item["exclusive"] && item["exclusive"] != "排他") {
      results.push({
        reviewPoint: "invalid",
        target: `${questionId} - 排他`,
        problem: "排他の欄に排他以外の値が設定されています",
        proposedRevision: `設問ID: ${questionId}の排他を修正してください`,
        must: false,
        questionId: questionId,
      });
    }

    // # random
    if (
      removeSpace(item["random"]) &&
      randomValues.filter((rv) => item["random"].includes(rv)).length == 0
    ) {
      results.push({
        reviewPoint: "invalid",
        target: `${questionId} - ランダム設定`,
        problem: "ランダム設定の入力値が不正です",
        proposedRevision: `設問ID: ${questionId}のランダム設定を修正してください`,
        must: false,
        questionId: questionId,
      });
    }
  });

  if (!question["questionType"].includes("TX")) {
    const uniqueItems = question.options.reduce((acc, i) => {
      if (!acc.includes(i["text"] && i["text"])) {
        return [...acc, i["text"]];
      }
      return acc;
    }, []);
    if (question.options.filter((i) => i.text).length > uniqueItems.length) {
      results.push({
        reviewPoint: "invalid",
        target: `${questionId} - 選択肢`,
        problem: "選択肢が重複しています",
        proposedRevision: `設問ID: ${questionId}の選択肢の重複を解消してください`,
        must: false,
        questionId: questionId,
      });
    }
  }

  // # loop
  if (question["loop"].length) {
    // loopの中で、同じ値がある場合、invalid
    if (question["loop"].length != new Set(question["loop"].map((i) => i["text"])).size) {
      results.push({
        reviewPoint: "invalid",
        target: `${questionId} - 行項目`,
        problem: "行項目が重複しています",
        proposedRevision: `設問ID: ${questionId}の行項目を修正してください`,
        must: false,
        questionId: questionId,
      });
    }
  }
  // # 回答形式に合わせたblankチェック
  if (question["questionType"].includes("マトリクス")) {
    // # マトリクス形式の場合、行項目が必須
    if (!question["loop"].length) {
      results.push({
        reviewPoint: "blank",
        target: `${questionId} - 行項目`,
        problem: "行項目が空白です",
        proposedRevision: `設問ID: ${questionId}の行項目を設定してください`,
        must: false,
        questionId: questionId,
      });
    } else {
      // 行項目のblankチェック
      question["loop"].forEach((item) => {
        if (!item["text"]) {
          results.push({
            reviewPoint: "blank",
            target: `${questionId} - 行項目`,
            problem: "行項目が空白です",
            proposedRevision: `設問ID: ${questionId}の行項目を設定してください`,
            must: false,
            questionId: questionId,
          });
        }
      });
    }
  }

  // exclusiveのチェック
  let exclusives = [];
  question.options.forEach((item) => {
    // itemGr.forEach((item) => {
    if (item["exclusive"]) {
      exclusives.push(item["exclusive"]);
    }
    // });
  });

  if (!question["questionType"].includes("MA")) {
    if (exclusives.length) {
      results.push({
        reviewPoint: "invalid",
        target: `${questionId} - 排他`,
        problem: "排他が設定されていますが、設問形式がMA以外です",
        proposedRevision: `設問ID: ${questionId}の排他を修正してください`,
        must: true,
        questionId: questionId,
      });
    }
  }
  if (exclusives.length > 1) {
    results.push({
      reviewPoint: "invalid",
      target: `${questionId} - 排他`,
      problem: "排他が複数存在しています",
      proposedRevision: `設問ID: ${questionId}の排他を修正してください`,
      must: true,
      questionId: questionId,
    });
  }

  // MASA混在マトリクスかつ、E列が表側かつ、L列が空白	→	混在MTXの指定をしてください。
  if (
    question["questionType"].includes("MASA混在") &&
    question["loop"].filter((i) => !i["answerType"]).length
  ) {
    results.push({
      reviewPoint: "blank",
      target: `${questionId} - 行項目`,
      problem: "回答形式がMASA混在マトリクスですが、行項目の回答形式が未設定です",
      proposedRevision: `設問ID: ${questionId}の行項目を設定してください`,
      must: true,
      questionId: questionId,
    });
  }
  // MAマトリクス（絞り込みあり）を選び、かつ、表示条件の指定がない時
  // →	マトリクス内絞り込み指示の記載があるかご確認ください。（ある場合でもこのアラートは出ます）
  if (
    (question["questionType"].includes("絞り込み") || question["questionType"].includes("絞込")) &&
    // !question["condition"] ||
    // question["condition"] == "ALL" ||
    question["loop"].filter((i) => i["condition"]).length == 0
  ) {
    results.push({
      reviewPoint: "blank",
      target: `${questionId} - 表示条件`,
      problem: "絞り込みありの設問ですが、表示条件が入力されていません",
      proposedRevision: `設問ID: ${questionId}の表示条件を修正してください`,
      must: true,
      questionId: questionId,
    });
  }

  return results;
}
